// Services data
export const services = [
  {
    id: "personal-care",
    title: "Personal Care",
    description: "Assistance with bathing, dressing, grooming, and personal hygiene to maintain dignity and comfort.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1589061434060-a05a5335bfbb?w=400"
  },
  {
    id: "medication-support",
    title: "Medication Support",
    description: "Ensuring medications are taken correctly and on time, with careful monitoring and documentation.",
    icon: "Pill",
    image: "https://images.unsplash.com/photo-1576602976047-174e57a47881?w=400"
  },
  {
    id: "meal-preparation",
    title: "Meal Preparation",
    description: "Nutritious meal planning and preparation tailored to dietary requirements and personal preferences.",
    icon: "UtensilsCrossed",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400"
  },
  {
    id: "companionship",
    title: "Companionship",
    description: "Social visits, conversation, and activities to reduce isolation and improve mental wellbeing.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1447069387593-a5de0862481e?w=400"
  },
  {
    id: "household-assistance",
    title: "Household Assistance",
    description: "Light housekeeping, laundry, shopping, and maintaining a safe, clean living environment.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400"
  },
  {
    id: "respite-care",
    title: "Respite Care",
    description: "Temporary relief for family carers, ensuring your loved one receives quality care while you rest.",
    icon: "Moon",
    image: "https://images.unsplash.com/photo-1516307365426-bea591f05011?w=400"
  },
  {
    id: "24-hour-care",
    title: "24-Hour Domiciliary Care",
    description: "Round-the-clock care and support for those requiring continuous assistance and supervision.",
    icon: "Clock",
    image: "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=400"
  }
];

// Core values
export const coreValues = [
  {
    title: "Compassion & Dignity",
    description: "We treat every individual with kindness, respect, and understanding.",
    icon: "Heart"
  },
  {
    title: "Professionalism",
    description: "Our team maintains the highest standards of care and conduct.",
    icon: "Award"
  },
  {
    title: "Reliability",
    description: "Consistent, dependable care you can count on, every single day.",
    icon: "Shield"
  },
  {
    title: "Respect & Inclusion",
    description: "Celebrating diversity and honoring individual choices and preferences.",
    icon: "Users"
  }
];

// Company info
export const companyInfo = {
  name: "Konastone Healthcare Ltd",
  tagline: "You're In Safe Hands!",
  address: "Brook House, 20 Brook St, Tipton DY4 9DD, England",
  phone: "07505 422205",
  email: "info@konastonehealthcare.co.uk",
  hours: {
    weekdays: "Monday – Friday: 9 AM – 5 PM",
    weekends: "Closed (scheduled home care visits available)"
  },
  rating: 5.0,
  location: "Brook Street Community Centre",
  socialMedia: {
    facebook: "https://www.facebook.com/share/1JK6Bk5KVK/",
    instagram: "https://www.instagram.com/konastonehealthcare/",
    linkedin: "https://linkedin.com/company/konastone-healthcare"
  },
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2430.8!2d-2.0744!3d52.5307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870972dd3927f0f%3A0x5a5da9a8bc8d7c5a!2sBrook%20St%2C%20Tipton!5e0!3m2!1sen!2suk!4v1"
};

// Navigation links
export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Team", path: "/team" },
  { name: "Testimonials", path: "/testimonials" },
  { name: "Blog", path: "/blog" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact", path: "/contact" },
  { name: "Admin", path: "/admin" }
];
